import Lottie from 'lottie-react';
import VegetableBasket from '../jsons/vegetable-basket.json';


const LottieVegetableBasket = props => {
  return <Lottie animationData={VegetableBasket} loop={false} {...props} />;
};

export default LottieVegetableBasket;
